module.exports = __webpack_public_path__ + "static/media/sales_meet_matt.12e28b1d.png";